import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withFocusFirstInput from 'components/common/hoc/withFocusFirstInput'
import CommunicationPreferencesDrawer from './CommunicationPreferencesDrawer'
import { submitUpdatePreferences, setCommunicationPreferencesEditMode } from './actions'

const withHandleUpdatePreferences = withHandlers({
  handleUpdatePreferences: ({ submitUpdatePreferences }) => preferences =>
    submitUpdatePreferences(preferences),
  editModeOn: ({ setCommunicationPreferencesEditMode }) => () =>
    setCommunicationPreferencesEditMode(true),
  editModeOff: ({ setCommunicationPreferencesEditMode }) => () =>
    setCommunicationPreferencesEditMode(false)
})

export default compose(
  connect(
    ({ communicationPreferences: { editMode }}) => ({ editMode }),
    {
      submitUpdatePreferences, setCommunicationPreferencesEditMode
    }),
  withHandleUpdatePreferences,
  withFocusFirstInput
)(CommunicationPreferencesDrawer)
